export type EtsyHealth = {
  connected: boolean
  provider: string
  reason?: string
}

export async function getEtsyHealth(brandId?: string): Promise<EtsyHealth> {
  try {
    const qs = brandId ? `?brandId=${encodeURIComponent(brandId)}` : ''
    const res = await fetch(`/api/etsy/health${qs}`)
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return (await res.json()) as EtsyHealth
  } catch {
    return { connected: false, provider: 'etsy', reason: 'network_error' }
  }
}
